/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import MessengerService from '@/services/MessengerService';
import SenderService from '@/services/SenderService';
import { WHATSAPP_OPERATIONS } from '@/services/metricsOperations';
import reportWhatsappFlowError from '@/services/reportWhatsappFlowError';
import canRequestLeadsStatus from './leadsStatusRequest';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`chat/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

const handlerWithMetrics = (name, asyncFunction, operation, contextPrefix) =>
  createAsyncThunk(`chat/${name}`, async (arg) => {
    try {
      return await asyncFunction(arg);
    } catch (error) {
      reportWhatsappFlowError(error, operation, contextPrefix || name);
      throw error;
    }
  });

export const updateChannelData = createAsyncThunk(
  'chat/updateChannelData',
  async (channel) => channel.data
);

export const setMessengerUserDataAsync = handler(
  'setMessengerUserDataAsync',
  MessengerService.getUserData
);

export const getAgentsChat = handler(
  'getAgentsChat',
  MessengerService.getAgentsChat
);

export const getDuplicateContacts = handler(
  'getDuplicateContacts',
  MessengerService.duplicateContacts
);

export const messengerManager = handler(
  'messengerManager',
  MessengerService.messengerManager
);

export const getLeadsStatus = createAsyncThunk(
  'chat/getLeadsStatus',
  () => MessengerService.getLeadsStatus(),
  {
    condition: (_, { getState }) =>
      canRequestLeadsStatus(getState().MessengerSlice?.leadsStatusRequest),
  }
);

export const getContact = handler('getContact', MessengerService.getContact);

export const changeLeadStatus = handler(
  'changeLeadStatus',
  MessengerService.changeLeadStatus
);

export const getPropertiesToShare = handler(
  'getPropertiesToShare',
  MessengerService.getPropertiesToShare
);

export const getQuickResponses = handler(
  'getQuickResponses',
  SenderService.getQuickResponses
);

export const getDevelopmentsToShare = handler(
  'getDevelopmentsToShare',
  MessengerService.getDevelopmentsToShare
);

export const deleteWebcontact = handler(
  'deleteWebcontact',
  MessengerService.deleteWebcontact
);

export const postCreateChannel = handler(
  'postCreateChannel',
  MessengerService.postCreateChannel
);

export const deleteMessage = handler(
  'deleteMessage',
  MessengerService.deleteMessage
);

export const getStarredsForEntity = handler(
  'getStarredsForEntity',
  MessengerService.getStarredsForEntity
);

export const desynchronizeWhatsapp = handlerWithMetrics(
  'desynchronizeWhatsapp',
  MessengerService.desynchronizeWhatsapp,
  WHATSAPP_OPERATIONS.DESYNCHRONIZE_WHATSAPP,
  'whatsapp_desynchronize'
);

export const sendWhatsappMessage = handler(
  'sendWhatsappMessage',
  MessengerService.sendWhatsappMessage
);

export const getBranches = handlerWithMetrics(
  'getBranches',
  MessengerService.getBranches,
  WHATSAPP_OPERATIONS.GET_BRANCHES,
  'company_branch'
);

export const patchBranch = handlerWithMetrics(
  'patchBranch',
  MessengerService.patchBranchPhone,
  WHATSAPP_OPERATIONS.PATCH_BRANCH_PHONE,
  'company_branch'
);

export const blockChannel = handlerWithMetrics(
  'blockChannel',
  MessengerService.blockChannel,
  WHATSAPP_OPERATIONS.BLOCK_CHANNEL,
  'tokko_chat_numbers_blacklist'
);

export const unblockChannel = handler(
  'unblockChannel',
  MessengerService.unblockChannel
);

export const acceptChannel = handlerWithMetrics(
  'acceptChannel',
  MessengerService.acceptChannel,
  WHATSAPP_OPERATIONS.ACCEPT_CHANNEL,
  'tokko_chat_channel_accept'
);

export const searchChat = handler('searchChat', MessengerService.searchChat);

export const fetchBlockedChannels = handler(
  'fetchBlockedChannels',
  MessengerService.getBlockedChannels
);
